import request from "./request";

const CatalogueService = {
    GetAll: async (searchText, context, signal) => {
        return await request.sendRequest(`/incident/all/search/${searchText}`, context.token, signal);
    },
    GetIncidents: async (searchText, context, signal) => {
        return await request.sendRequest(`/incident/search/${searchText}`, context.token, signal);
    },
    HasIncidents: async (context, signal) => {
        return await request.sendRequest(`/incident/hasdata`, context.token, signal);
    },
    GetIncidentDashboard: async (context, signal) => {
        return await request.sendRequest(`/incident/dashboard/incidents`, context.token, signal);
    },
    GetIncidentCoursesDashboard: async (context, signal) => {
        return await request.sendRequest(`/incident/dashboard/incidents/courses`, context.token, signal);
    },
    GetIncidentLearnerDashboard: async (context, signal) => {
        return await request.sendRequest(`/incident/dashboard/incidents/learners`, context.token, signal);
    },
    GetAllByCourseId: async (id, searchText, context) => {
        return await request.sendRequest(`/incident/all/course/${id}/search/${searchText}`, context.token);
    },
    GetAllByCategoryId: async (id, searchText, context, signal) => {
        return await request.sendRequest(`/incident/category/${id}/search/${searchText}`, context.token, signal);
    },
    GetCategories: async (context, signal) => {
        return await request.sendRequest(`/incident/categories`, context.token, signal);
    },
    GetCategoryList: async (context, signal) => {
        return await request.sendRequest(`/incident/category/list`, context.token, signal);
    },
    GetParentCategoryList: async (context, signal) => {
        return await request.sendRequest(`/incident/category/parent/list`, context.token, signal);
    },
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/incident/${id}`, context.token, signal);
    },
    MarkAsCompleted: async (id, context) => {
        return await request.sendPutRequest(`/incident/completed/${id}`, context);
    },
    MarkAsIncomplete: async (id, context) => {
        return await request.sendPutRequest(`/incident/incomplete/${id}`, context);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/incident`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/incident/${id}`, context.token);
    },
    SaveCategoryOrder: async (authContext, payload, signal) => { 
        return await request.sendPostRequest( "/Category/order", payload, authContext, signal ); 
    },
    SaveChildCategoriesOrder: async (authContext, payload, signal) => {
        return await request.sendPostRequest('/Category/child/order',payload,authContext,signal);
    },
    SaveIncidentsOrder: async (authContext, payload, signal) => {
        return await request.sendPostRequest('/Incident/orderBy',payload,authContext,signal);
    },
    };

export default CatalogueService;
